export default __webpack_public_path__ + "static/media/a-whisper-in-the-darkness.87f9b5e3.jpg";